
// 根据测试环境区分appid，当前仅支持temp用759
let appID = '759';
const domain = window.location.hostname;
if (domain.indexOf('aigc-fe-test.now.baidu.com') >= 0
    || domain.indexOf('aigc-fe-dev.now.baidu.com') >= 0
    || domain.indexOf('aigc-fe-offline.now.baidu.com') >= 0
    || domain.indexOf('aigc-fe-tmp.now.baidu.com') >= 0
) {
    appID = '3';
}

export const APP_ID = appID;

// 用户敏捷调研sdk的appId
export const APP_ID_BASS = 83;

// 线下环境的NODE_ENV也是production，不好区分测试环境与线上环境的编译版本，通过额外参数区分
const isOnline = process.env.VUE_APP_VERSION === 'online';

// token在账号 商业aigc 下，
// 测试环境token: 1cd69b47666b76fea3427f84c4dcf770；
// 线上token: 6cb2dc99b973ab824856edca4e054dd1

export const tongjiToken = !isOnline ? '1cd69b47666b76fea3427f84c4dcf770' : '6cb2dc99b973ab824856edca4e054dd1';
